import { render, staticRenderFns } from "./SendRegiLabel.vue?vue&type=template&id=de4cf764&scoped=true&"
import script from "./SendRegiLabel.vue?vue&type=script&lang=js&"
export * from "./SendRegiLabel.vue?vue&type=script&lang=js&"
import style0 from "./SendRegiLabel.vue?vue&type=style&index=0&id=de4cf764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4cf764",
  null
  
)

export default component.exports